import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';
import { v4 as uuidv4 } from 'uuid';
import CustomCheck from '../../../../Common/customComponents/CustomCheck.tsx';
import CustomText from '../../../../Common/customComponents/CustomText.tsx';

interface IProps {
  ref?: any;
  section: any;
  data: any;
}

const View = (props: IProps) => {
  return (
    <Fragment>
      <div
        className={'preview-list-area ' + (props.section.hasComment && ' preview-bottom-border')}
      >
        {props.section.items?.map((item: any, ii: number) => {
          var addRender = item.addRender;
          var addRenderType = null;
          var addRenderLabels = [];
          if (addRender) {
            addRenderType = addRender['TYPE'];
            addRenderLabels = addRender['LABELS'];
          }
          //console.log(addRenderLabels);
          return (
            <div className={'preview-item-ynnar-group'} key={ii}>
              <span className={'preview-section-ynnar-label'}>{item.label}</span>
              <div className={'preview-section-ynnar-y'}>
                <span className={'preview-section-ynnar-r-label'}>
                  {props.data && props.data.formData && props.data.formData[item.itemName] === 'Y'
                    ? '✔'
                    : ''}
                </span>
              </div>
              <div className={'preview-section-ynnar-n'}>
                <span className={'preview-section-ynnar-r-label'}>
                  {props.data && props.data.formData && props.data.formData[item.itemName] === 'N'
                    ? '✔'
                    : ''}
                </span>
              </div>
              <div className={'preview-section-ynnar-na'}>
                <span className={'preview-section-ynnar-r-label'}>
                  {props.data && props.data.formData && props.data.formData[item.itemName] === 'NA'
                    ? '✔'
                    : ''}
                </span>
              </div>
              <div className={'preview-section-ynnar-r'}>
                <span
                  className={'preview-section-ynnar-r-label preview-section-flow-area'}
                  style={{ padding: '0' }}
                >
                  {addRenderType === 'REMARK_PRE_TEXT' ? (
                    <span style={{ fontSize: '8px' }}>{item.addRender['TEXT'] + ' '}</span>
                  ) : (
                    ''
                  )}
                  {addRenderType === 'REMARK_CHECK' &&
                    addRenderLabels?.map((__item: any, __i: number) => (
                      <div
                        key={__i}
                        className={'preview-item-check-group'}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        <input
                          type={'checkbox'}
                          readOnly={true}
                          checked={
                            props.data &&
                            props.data.formData &&
                            props.data.formData[item.itemName + '-REMARKS-' + __i]
                              ? props.data.formData[item.itemName + '-REMARKS-' + __i]
                              : false
                          }
                        />
                        <label>{__item}</label>
                      </div>
                    ))}
                  {addRenderType !== 'REMARK_CHECK' &&
                    props.data &&
                    props.data.formData &&
                    props.data.formData[item.itemName + '-REMARKS']}
                </span>
              </div>
            </div>
          );
        })}
      </div>
      {props.section.hasComment && (
        <div className={'saf-border-bottom-none'}>
          <div className={'preview-text-02'}>Comment :</div>
          <div className={'saf-min-h50'}></div>
        </div>
      )}
    </Fragment>
  );
};

export default View;
